export const FETCH_DASHBOARDS = "FETCH_DASHBOARDS";
export const LIST_DASHBOARDS = "LIST_DASHBOARDS";